import * as types from './types'
export const mutations = {
  [types.FETCH_RULES](state, payload) {
    state.rules = payload.rules
  },
  [types.SET_HASID](state, payload) {
    state.hasId = payload.hasId
  }
}



// WEBPACK FOOTER //
// ./src/stores/rules/mutations.js